import { useSelector } from 'react-redux';
import {
  selectCreationFormData,
  selectCurrentTeamMemberData,
  selectFilterData,
  selectFilterCriteriaData
} from 'pages/TeamSchedule/TeamList/selectors';
import { selectUnsavedFormData } from 'pages/commonSelectors';

export function useTeamMemberSelector() {
  const currentTeamMember = useSelector(selectCurrentTeamMemberData());
  const creationFormData = useSelector(selectCreationFormData());

  const unsavedFormData = useSelector(selectUnsavedFormData());

  const filter = useSelector(selectFilterData());
  const filterCriteria = useSelector(selectFilterCriteriaData());

  return {
    filter,
    filterCriteria,
    currentTeamMember,
    creationFormData,
    unsavedFormData
  };
}
